window.addEventListener('message', event => {
    if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
        // the form is ready to manipulate!
        if( !jQuery('body').hasClass('hoyla-ready') ){
            jQuery('#hoyla-form .hs-form > *:gt(0)').wrapAll("<div class='contact-fields'></div>");
            jQuery('#hoyla-form .hs-form > *:nth-child(1)').append("<div class='button-wrapper next step-1'><a href='#' class='button'>Siirry täyttämään yhteystiedot »</a></div>");
            jQuery('#hoyla-form .hs-form > *:nth-child(1)').prepend("<div class='step-wrapper step-1'><span class='step'>Vaihe 1/2</span></div>");
            jQuery('#hoyla-form .hs-form > *:nth-child(2)').append("<div class='buttons-wrapper'><div class='button-wrapper prev step-2'><a href='#' class='button'>« Palaa takaisin</a></div></div>");
            jQuery('#hoyla-form .hs-form > *:nth-child(2)').prepend("<div class='step-wrapper step-2'><span class='step'>Vaihe 2/2</span></div>");
            //jQuery('#hoyla-form .hs-form > *:nth-child(3)').append("<div class='button-wrapper prev step-3'><a href='#' class='button'>« Palaa takaisin</a></div>");
            //jQuery('#hoyla-form .hs-form > *:nth-child(3)').prepend("<div class='step-wrapper step-3'><span class='step'>Vaihe 3/3</span></div>");
            jQuery('body').addClass("hoyla-ready");
        }
        
        jQuery('.button-wrapper.next.step-1 a').click(function(e){
            e.preventDefault();
            jQuery('#hoyla-form .hs-form > *:nth-child(1)').fadeOut();
            jQuery('#hoyla-form .hs-form > *:nth-child(2)').fadeIn();
            jQuery('#hoyla-form .hs-form > *:nth-child(3)').fadeOut();
        });
        jQuery('.button-wrapper.next.step-2 a').click(function(e){
            e.preventDefault();
            jQuery('#hoyla-form .hs-form > *:nth-child(1)').fadeOut();
            jQuery('#hoyla-form .hs-form > *:nth-child(2)').fadeOut();
            jQuery('#hoyla-form .hs-form > *:nth-child(3)').fadeIn();
        }); 

        jQuery('.button-wrapper.prev.step-2 a').click(function(e){
            e.preventDefault();
            jQuery('#hoyla-form .hs-form > *:nth-child(1)').fadeIn();
            jQuery('#hoyla-form .hs-form > *:nth-child(2)').fadeOut();
            jQuery('#hoyla-form .hs-form > *:nth-child(3)').fadeOut();
        });  
        jQuery('.button-wrapper.prev.step-3 a').click(function(e){
            e.preventDefault();
            jQuery('#hoyla-form .hs-form > *:nth-child(1)').fadeOut();
            jQuery('#hoyla-form .hs-form > *:nth-child(2)').fadeIn();
            jQuery('#hoyla-form .hs-form > *:nth-child(3)').fadeOut();
        });  
  
    }
 });
